export default __webpack_public_path__ + "static/media/empty-review-img.d998c3cb.svg";